import { render, staticRenderFns } from "./VuesticWidget.vue?vue&type=template&id=23293716&"
import script from "./VuesticWidget.vue?vue&type=script&lang=js&"
export * from "./VuesticWidget.vue?vue&type=script&lang=js&"
import style0 from "./VuesticWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VuesticWidget.vue"
export default component.exports